export default path => '/my-account/vehicle-details'.includes(path)
